export const pitchTypes = [
  { value: "INDIVIDUAL", label: "INDIVIDUAL" },
  { value: "FRIENDLY", label: "FRIENDLY" },
  { value: "FULL-PITCH", label: "FULL-PITCH" },
];

export const FORMIKERROR = {
  fontSize: "12px",
  color: "red",
  marginTop: "3px",
};
